module.exports = __webpack_public_path__ + "media/images/front/pc/for-doctors-refine/bg_kv-54d52589f254fa4ed258ee9e81a5e7e2.png";